import axios from "axios";
import config from '../config/index';
import {responseIntercept,errorIntercept} from '~/utils/interceptor'

export default class Project {
  static instance = axios.create({
    baseURL: config.backendUri + '/api',
    headers:{
      Authorization:'Bearer ' + localStorage.getItem('token')
    }
  });

  static instanceConfig () {
    this.instance.interceptors.request.use(configH => {
      const token = localStorage.getItem('token');
      configH.headers.Authorization = `Bearer ${token}`;
      return configH;
    });

    this.instance.interceptors.response.use(responseIntercept,errorIntercept);
  }


  static async getCompanyWithId (id) {
    this.instanceConfig();
    const resp = await (await this.instance.get(`company/${id}`)).data;
    return resp;
  }

  static async updateCompany (userInfo) {
    const resp = await (await this.instance.put('user', userInfo)).data;
    return resp;
  }

  static async updateCompanyRole (_id, roleCategory, rolesArray) {
    const resp = await (await this.instance.put("/company-roles", {_id, roleCategory, rolesArray})).data;
    return resp;
  }
  

}
